import { render, staticRenderFns } from "./consultHistory.vue?vue&type=template&id=12556177"
import script from "./consultHistory.vue?vue&type=script&lang=js"
export * from "./consultHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12556177')) {
      api.createRecord('12556177', component.options)
    } else {
      api.reload('12556177', component.options)
    }
    module.hot.accept("./consultHistory.vue?vue&type=template&id=12556177", function () {
      api.rerender('12556177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/consultHistory.vue"
export default component.exports